//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: {
    spec: {
      type: Object,
      required: true
    }
  },
  methods: {
    classes: function classes() {
      return this.$classes().concat("layouts-split");
    }
  }
};